import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../context/userContext";
import { useNavigate, useParams } from "react-router-dom";
import { Table } from "react-bootstrap";
import {Row,Col,Form,Input,Label,Button,CardText,CardTitle,FormFeedback,UncontrolledTooltip} from 'reactstrap'
import { useMediaQuery } from 'react-responsive'
import { API, setAuthToken } from "../../config/api";
import {FaUser,FaUserMd, FaGenderless, FaMailBulk, FaTransgender, FaPhone, FaAddressBook, FaAddressCard, FaEdit, FaTrash, FaSave, FaPlus, FaSearch, FaUserAlt, FaAccessibleIcon, FaCriticalRole, FaUserClock, FaUserCheck, FaAccusoft, FaArchive, FaBackspace, FaBackward, FaArrowCircleLeft, FaRegArrowAltCircleLeft, FaEyeDropper, FaRegEye, FaMehRollingEyes, FaBullseye, FaStreetView, FaEye, FaPerbyte, FaAngleUp, FaAdjust, FaMizuni, FaCreativeCommonsZero, FaCreativeCommons, FaAward, FaStethoscope, FaListOl, FaDAndD, FaDailymotion, FaGasPump, FaDesktop, FaFileMedical, FaBookMedical, FaCalendar, FaCalendarDay, FaCalendarAlt, FaTransgenderAlt, FaBirthdayCake, FaCalendarCheck, FaPhoenixFramework, FaPhoneAlt, FaPhoneSlash, FaMobile, FaMobileAlt, FaMarsStroke, FaWpforms, FaSync, FaUserPlus, FaTag, FaRegEdit, FaUserEdit, FaMedkit, FaNotesMedical, FaUndo, FaArrowLeft, FaUndoAlt, FaArrowAltCircleLeft, FaHeadSideCough, FaHeadphones, FaClinicMedical, FaBriefcaseMedical} from 'react-icons/fa'
import ReactPaginate from "react-paginate";
import Modal from 'react-bootstrap/Modal';
import logo_side from "../../assets/signature/logo-side-detail.png"
import Logo_Signature from "../../assets/signature/signatureNewIcon.png"
import Logo_Batik from "../../assets/signature/logo-batik.png"
import "bulma/css/bulma.css";
import { useMutation } from "react-query";
import "../../index.css"
import Swal from "sweetalert2";
import swal from "sweetalert";
// Modal Role
import ModalAddMedis from "./ModalMedicalRecord/ModalAdd"
import ModalUpdateMedis from "./ModalMedicalRecord/ModalUpdate"
import { ScaleLoader } from "react-spinners";
import LoaderHome from "../Loader/LoaderHome"

export default function Login() {
  // let navigate = useNavigate();
  // useEffect(() => {
  //   if (localStorage.getItem("token") == null || undefined) {
  //       navigate("/");
  //     }
  // }, []);
  document.title = "SDC Apps";
  const navigate = useNavigate()
  const [getData, setGetData] = useState([]);
  const [getDataRekamMedis, setGetDataRekamMedis] = useState([]);
  const [pagination,setPagination] = useState([])
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [pages, setPages] = useState();
  const [ascending, setAscending] = useState(0);
  const [rows, setRows] = useState(1);
  const [keyword, setKeyword] = useState("");
  const [query, setQuery] = useState("");
  const [msg, setMsg] = useState("");
  const token = localStorage.getItem("token");
  const [idDelete, setIdDelete] = useState(null);
  const [confirmDelete, setConfirmDelete] = useState(null);
  const [show, setShow] = useState(false);
  const [search,setSearch] = useState("")
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [dataMap, setDataMap] = useState("");
  const [dataSearch, setDataSearch] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const style = { position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)" };
  // Responsive to mobile or dekstop
  const isDesktopOrLaptop = useMediaQuery({query: '(min-width: 1224px)'})
  const isBigScreen = useMediaQuery({ query: '(min-width: 1824px)' })
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)'})
  const isPortrait = useMediaQuery({ query: '(orientation: portrait)'})
  const isRetina = useMediaQuery({ query: '(min-resolution: 2dppx)' })
  // modal role add 
  const [idModal, setIdModalUpdate] = useState();
  const [idModalAdd, setIdModalAdd] = useState();
  const [codeGenerata, setCodeGenerate] = useState()
  const { id, code } = useParams()
  const [modalAdd, setModalAdd] = useState(false);
  const [modalUpdate, setModalUpdate] = useState(false);
  const [loading, setLoading] = useState(false);


  let fetchParams = {
    headers : {"Authorization" : `${token}`,"Content-Type" : "application/json"}
  };

  const GetResponseData = async () => {
    setLoading(true)
    const response = await API.get(`emr-service/medical-records?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}&search=${search}&id_patient=${id}`,fetchParams)
    if (response.data.data.length !== 0) {
      setGetData(response.data.data)
      setGetDataRekamMedis(response.data.data[0].patient_data)
      setPage(response.data.pagination.current_page);
      setPages(response.data.pagination.total_pages);
      setRows(response.data.pagination.total);
    } 
    setLoading(false)
  }

  useEffect(() => {
    GetResponseData()
  }, [page])

  const deleteById = async (id) => {
    Swal.fire({
      title: 'Apakah Kamu Yakin?',
      text: `Menghapus data ini`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Ya, Hapus'
    }).then( async (result) => {
      if(result.isConfirmed) {
        const response =  await API.delete(`emr-service/med-attentions/${id}`,fetchParams);
        if (response.data.error == false) {
          GetResponseData()
          swal({
            title: 'Success',
            text: "Your data has been successfully deleted",
            icon: 'success',
            timer: 3000,
            buttons: false
          });
        }  
      }
    })
  };

  const changePage = ({ selected }) => {
    setPage(selected+1);
    if (selected === 10) {
      setMsg(
        ""
      );
    } else {
      setMsg("");
    }
  };
 
  const searchData = (e) => {
    e.preventDefault();
    setPage(0);
    setMsg("");
    setKeyword(query);
  };

  const navigateHome = () => {
    navigate('/patients');
  }

  const buttonRefresh = () => {
    window.location.reload();
  }
  
  const viewModalAdd = () => {
    setCodeGenerate(code)
    setIdModalAdd(id)
    setModalAdd(true)
  }

  const viewModalUpdate = (id) => {
    setModalUpdate(true)
    setIdModalUpdate(id)
  }

  let modalMedicalRecord = async (id) => {
    navigate('/odontograms/'+ id )
  };


  return (
    <div style={{ backgroundColor: "white", marginTop: "15px", marginLeft: "10px", marginRight: "10px", boxShadow: "2px 2px 10px #BFBFBF" }}>

      {modalAdd  && <ModalAddMedis codeGenerata={codeGenerata} idModalAdd={idModalAdd} show={modalAdd} onHide={() => setModalAdd(false)} />}
      {modalUpdate && <ModalUpdateMedis idModal={idModal} show={modalUpdate} onHide={() => setModalUpdate(false)} />}
      {loading && <LoaderHome />}
      

      <div style={{ paddingLeft: "0px", width: "100%", borderBottom: "5px solid #EEEEEE", display: "flex", padding: "10px 0px" }}>
      <div style={{flex:"50%",fontSize:"16px",display:"flex", aunlocklignItems:"center", paddingLeft:"10px", color:"#001F8B"}}>
        <div onClick={navigateHome} style={{display:"flex" , marginRight:"10px",fontSize: "11px", color: "white", backgroundColor: "#C3C3C3", padding: "5px 10px", borderRadius: "3px", cursor: "pointer", border: "none"}}>
        <div style={{ marginRight: "3px", display:"flex" }}>
          <div style={{display:"flex",alignItems:"center", height:"100%"}}>
          <FaRegArrowAltCircleLeft style={{display:"flex",alignItems:"center", fontSize:"15px"}}/>
          </div>
          </div>
          <div style={{ display: "flex" }}>
            <div style={{display:"flex", alignItems:"center", height:"100%", fontSize:"12px"}}>
              Kembali
            </div>
          </div>
        </div>
            MEDICAL RECORD <div style={{color:"black", marginLeft:"5px", fontFamily:"revert", textDecoration:"underline"}}>{getData.length !== 0 ? `${getDataRekamMedis?.first_name} ${getDataRekamMedis?.last_name}` : "Kosong" }</div>      </div>
        <div style={{ flex: "50%", display: "flex", justifyContent: "end" }}>
        <div onClick={viewModalAdd} style={{display:"flex",alignItems:"center",marginRight:"15px",backgroundColor:"#3D64FF",color:"white",padding:"0px 10px", boxShadow:"1px 1px 4px #8B8B8B", borderRadius:"3px", cursor:"pointer", fontSize:"12px", cursor:"pointer"}}>
         Periksa Pasien
      </div>
      <div onClick={buttonRefresh} style={{height:"100%", marginRight:"5px", paddingTop:"0px",backgroundColor:"white",padding:"0px 10px", boxShadow:"1px 1px 4px #8B8B8B", borderRadius:"3px", cursor:"pointer"}}>
        <FaSync style={{ fontSize: "15px", marginRight: "0px", marginTop: "0px", display: "flex", alignItems: "center", height:"100%", color:"#3D64FF" }} />
      </div>
      <form onSubmit={searchData} style={{display:"flex", paddingRight:"0px"}}>
                <div style={{marginRight:"5px",borderRadius:"3px"}}>
                    <input value={query}
                              onChange={(e) => setQuery(e.target.value)}
                    className="focused"
                    style={{backgroundColor:"#E9E9E9", border:"none",height:"100%"}}
                    type="text"
                    placeholder=""
                  />
              </div>
                <button type="submit"  style={{ border: "none", backgroundColor: "#3D64FF", color: "white", display: "flex", borderRadius:"2px", fontWeight:"600", fontSize:"12px",alignItems:"center", padding:"0px 10px" }}>
                  Search
                </button>
        </form>
      </div>
    </div>
 
  <Col xl='12' sm='12'> 
  <div>
    <div style={{display:"block", height:"100%", overflowY:"auto",overflowX:"auto"}}>
      <div >
        <table className="table is-bordered">
          <thead>
            <tr style={{backgroundColor:""}}>
              <th style={{ fontFamily: "revert", fontSize: "12px", textAlign: "center", color: "#525252", border: "none", fontFamily: "sans-serif" }}>No</th>
              {/* <th style={{ fontFamily: "revert", fontSize: "12px", textAlign: "center", color: "#525252", border: "none", fontFamily: "sans-serif" }}>Code Medical Record</th>       */}
              <th style={{ fontFamily: "revert", fontSize: "12px", textAlign: "center", color: "#525252", border: "none", fontFamily: "sans-serif" }}>Tanggal Pemeriksaan</th>
              <th style={{ fontFamily: "revert", fontSize: "12px", textAlign: "center", color: "#525252", border: "none", fontFamily: "sans-serif" }}>Mulai Perawatan</th>
              <th style={{ fontFamily: "revert", fontSize: "12px", textAlign: "center", color: "#525252", border: "none", fontFamily: "sans-serif" }}>Jenis Perawatan</th>
              {/* <th style={{ fontFamily: "revert", fontSize: "12px", textAlign: "center", color: "#525252", border: "none", fontFamily: "sans-serif" }}>Selesai Perawatan</th> */}
              <th style={{ fontFamily: "revert", fontSize: "12px", textAlign: "center", color: "#525252", border: "none", fontFamily: "sans-serif" }}>Diagnosa</th>
              {/* <th style={{ fontFamily: "revert", fontSize: "12px", textAlign: "center", color: "#525252", border: "none", fontFamily: "sans-serif" }}>Odontogram</th> */}
              <th style={{ fontFamily: "revert", fontSize: "12px", textAlign: "center", color: "#525252", border: "none", fontFamily: "sans-serif" }}>Create By</th>
              {/* <th style={{fontFamily:"revert",fontSize:"12px",textAlign:"center",  color:"#525252",border:"none", fontFamily:"sans-serif"}}>Setup</th> */}
            </tr>
          </thead>
                {getData.length !== 0 ?
                  <tbody>    
                  {getData.map((user,index) => (
                  <tr key={index} style={{fontFamily:"sans-serif", fontSize:"11px", textAlign:"center"}}>
                      <td style={{ lineHeight: "2" }}>{page === 1 ? index + 1 : page === 2 ? (index + 1) + 10 : (index + 1) + (page * 10)}</td>
                      {/* <td style={{ lineHeight: "2" }}>{user.code}</td> */}
                      <td style={{ lineHeight: "2" }}>
                        {user.date_check.split('-')[2]}&nbsp;
                        {user.date_check.split('-')[1] === "01" ? "Januari" : "" ||
                        user.date_check.split('-')[1] === "02" ? "Februari" : "" ||
                        user.date_check.split('-')[1] === "03" ? "Maret" : "" ||
                        user.date_check.split('-')[1] === "04" ? "April" : "" ||  
                        user.date_check.split('-')[1] === "05" ? "Mei" : "" ||
                        user.date_check.split('-')[1] === "06" ? "Juni" : "" ||
                        user.date_check.split('-')[1] === "07" ? "Juli" : "" ||
                        user.date_check.split('-')[1] === "08" ? "Agustus" : "" ||
                        user.date_check.split('-')[1] === "09" ? "September" : "" ||
                        user.date_check.split('-')[1] === "10" ? "Oktober" : "" ||
                        user.date_check.split('-')[1] === "11" ? "November" : "" ||
                        user.date_check.split('-')[1] === "12" ? "Desember" : ""}&nbsp;
                        {user.date_check.split('-')[0]}
                      </td>
                      <td style={{ lineHeight: "2" }}>
                        <div style={{  display:"flex", justifyContent:"center" }}>
                          <div style={{ borderRadius:"3px", fontWeight:"bold", backgroundColor:"#FFB450", color:"white", padding:"0px 5px"}}>
                            {user.start_time? user.start_time.split(':')[0] : ""} : {user.start_time? user.start_time.split(':')[1] : ""}
                          </div>
                        </div>
                      </td>
                      <td style={{ lineHeight: "2" }}>{user.treatment_data === null? "" : user.treatment_data.name}</td> 

                      {/* <td style={{ lineHeight: "2" }}></td> */}
                      <td style={{ lineHeight: "2" }}>{user.diagnose}</td> 

                      {/* <td style={{ lineHeight: "2" }}>
                        <div className="mt-1" style={{display:"flex",justifyContent:"center"}}>
                          <div onClick={() => modalMedicalRecord(user?.id, user?.code)} style={{display:"flex",border:"none", padding:"0px 7px", cursor:"pointer", borderRadius:"3px", backgroundColor:"#00D5FF", color:"white", fontWeight:"bold",width:"120px", justifyContent:"center"}}>
                            <div  style={{display:"flex", alignItems:"center", marginRight:"5px"}}>
                              <FaBriefcaseMedical style={{}}/>
                            </div>
                            <div style={{display:"flex", alignItems:"center"}}>
                              Odontogram
                            </div>
                          </div>
                        </div>
                      </td>   */}

                      <td style={{ lineHeight: "2" }}>
                        <div style={{display:"flex", justifyContent:"center"}}>
                          <div>
                            <img src={user.create_by_data.photo_profile} style={{ maxWidth: "20px", minWidth: "20px", borderRadius: "100px", border: "2px solid #6C85FF" }} />
                          </div>
                          <div style={{ marginLeft: "5px" }}>
                            {user.create_by_data.username}
                          </div>
                        </div>
                      </td>

                      {/* <td style={{lineHeight:"2"}}>
                        <div style={{display:"flex",justifyContent:"center", alignItems:"center", alignContent:"center"}}>
                            <button onClick={() => viewModalUpdate(user?.id)} style={{ fontSize: "13px", color: "white", backgroundColor: "#ff9933", padding: "5px 5px", borderRadius: "3px", cursor: "pointer", border: "none", display:"flex", marginRight:"3px" }}>
                              <FaEdit/>
                            </button>
                            <button onClick={() => {deleteById(user?.id)}} style={{ fontSize: "12px", color: "white", backgroundColor: "#B60000", padding: "5px 5px", borderRadius: "3px", cursor: "pointer", border: "none", display:"flex" }}>
                              <FaTrash/>
                            </button>
                        </div>
                    </td>  */}

                  </tr>
                ))}
              </tbody>
                  :
              <tbody>    
                
              </tbody>
              }                
              </table>
          {/* <div style={{ display: "flex", padding:"10px"}}>
          <div>
            <div style={{fontSize:"12px"}}>
              Total Rows: {rows} 
            </div>
            <div style={{fontSize:"12px"}}>
              Page: {rows ? page : 0} of {pages}
            </div>
            <p className="has-text-centered has-text-danger">{msg}</p>
          </div> 
            <div style={{flex:"50%", display:"flex", justifyContent:"end"}}>
              <nav
                    style={{fontSize:"12px"}}
                    className="pagination is-centered"
                    key={rows}
                    role="navigation"
                    aria-label="pagination"
                    >
                    <ReactPaginate
                      previousLabel={"<"}
                      nextLabel={">"}
                      pageCount={Math.min(10, pages)}
                      onPageChange={changePage}
                      containerClassName={"pagination-list"}
                      pageLinkClassName={"pagination-link"}
                      previousLinkClassName={"pagination-previous"}
                      nextLinkClassName={"pagination-next"}
                      activeLinkClassName={"pagination-link is-current"}
                      disabledLinkClassName={"pagination-link is-disabled"}
                    />
                  </nav>
              </div>
            </div>      */}
          </div>
        </div>
      </div>
  </Col>

</div>
  );
}
